import './style.scss';
import { Link } from 'react-router-dom';
import Logo from 'components/atoms/Logo';

function HomeLink(props) {
  return (
    <div className="HomeLink">
      <Link className="HomeLink__link" to="/">
        <Logo className="HomeLink__image" alt="Cogny" />
      </Link>
    </div>
  );
}

export default HomeLink;
